import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { environment } from '../../environments/environment';
import { BestwalletComponent } from '../modals/bestwallet/bestwallet.component';
import { getParamWithoutCookie, getReferrer, handleLastClickTracking } from '../shared/constants/app-enums';
import { getDynamicAmount } from '../shared/constants/wallet-connect.const';
import { IBalnceDataEVM } from '../shared/interfaces/wallet.interface';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  modalRef?: BsModalRef;
  referUrl = '';
  private readonly http = inject(HttpClient);
  private readonly modalService = inject(BsModalService);

  constructor() { }

  /**
   * function to update analytics data
   * @param flowName: process name like swap/connectWallet
   * @param stepName: swapSuccessful/confirmTransaction/successful
   * @param stepNo: step no of process
   * @param completeFlag: is omppletedd or not
   * @param errorCode: if any error
   * @param fromCurrency: ETH/BNB/POLY/USDT
   * @param toCurrency : ICO/APP token
   * @param fromVal: ETH/BNB/USDT value
   * @param toVal: App token value
   */
  async windowDataLayer(
    flowName: string,
    stepName: string,
    stepNo: number,
    completeFlag: number,
    errorCode: number,
    fromCurrency: string = '',
    toCurrency: string = '',
    fromVal: number = 0,
    toVal: number = 0,
    walletAddress: string,
    swapHash: string,
    balanceData: IBalnceDataEVM,
    chainId: number,
    tokenUSDT: number,
  ) {
    if (typeof window == 'undefined') return;
    if (environment.production) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'workflowStep',
        walletAddress: walletAddress,
        workflowName: flowName, // "swap",
        workflowStepNumber: stepNo, // 2,
        workflowStepName: stepName, // "confirmTransaction",
        workflowCompleteFlag: completeFlag,
        workflowErrorCode: errorCode,
        transactionId: completeFlag === 0 ? undefined : swapHash,
        swapFromValue: completeFlag === 0 ? undefined : fromVal, // value,
        swapToValue: completeFlag === 0 ? undefined : toVal, // amount,
        swapFromCurrency: completeFlag === 0 ? undefined : fromCurrency, // "ETH/BNB/POLY/USDT",
        swapToCurrency: completeFlag === 0 ? undefined : toCurrency, // "token name"
        presaleStage: completeFlag === 0 ? undefined : balanceData.currentStep, // current running stage
        stageTokenValue: completeFlag === 0 ? undefined : tokenUSDT, // current running stage's token usdt value
        swapFromValueUsd: completeFlag === 0 ? undefined : await getDynamicAmount(toVal, 'getUSDTAmount', chainId, balanceData),
      });
    }
  }

  /**
   * DashFx is another analytics feature
   * @param type : connect wallet/ETH/BNB/USDT
   * @param toValue: App token value
   * @param fromValue : ETH/BNB/USDT value
   * @param connectMode: whether it is wallet connect or not
   */

  sendDashFx = (walletAddress: string) => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
    if (environment.production && !environment.isClaimEnabled) {
      const trackingData = handleLastClickTracking(['clickId', 'source', 'tid', 'pid']);
      const data = {
        walletAddress: walletAddress,
        iid: environment.iidDashFx,
        event: 'lead_success',
        purchaseType: null,
        purchaseTokens: 0,
        purchaseTypeAmount: 0,
        purchaseUsdAmount: 0,
        ipAddress: '',
        clickId: trackingData['clickId'],
        source: trackingData['source'],
        pid: trackingData['pid'],
        tid: trackingData['tid'],
        referrer: getReferrer(),
        userAgent: navigator.userAgent || '',
        acceptLanguage: '',
      };
      const dashURL = environment.server === 'aws' ? environment.urlDashFx_aws
        : environment.server === 'firebase' ? environment.urlDashFx_firebase
          : environment.urlDashFx_cloudfront;

      this.http.post(dashURL, data).subscribe(
        (res: any) => {
          console.log('DashFx success response', res);
        },
        (err: any) => {
          console.log('DashFx error response', err);
        },
      );
    }
  };

  /**
   * Refer function to get URL
   * to share with friends
   */

  /**
   * BestWallet Data analytics
   * @param type : connect wallet/ETH/BNB/USDT
   * @param toValue: App token value
   * @param fromValue : ETH/BNB/USDT value
   * @param connectMode: whether it is wallet connect or not
   */

  sendBWData = (type: string, toValue: number, fromValue: number, walletAddress: string, swapHash: string, chainId: number, mode: string, balanceData: IBalnceDataEVM, tokenUSDT: number) => {
    if (typeof window === 'undefined') return;
    if (environment.production) {
      const tokens: number = balanceData.ethClaimable || 0;
      const trackingData = handleLastClickTracking(['clickId', 'source', 'tid', 'pid']);
      const data = {
        publicAddress: walletAddress,
        event: tokens > toValue ? 'revenue' : 'conversion',
        purchaseType: type,
        purchaseTokens: +toValue,
        purchaseTypeAmount: +fromValue,
        purchaseUsdAmount: type === 'usdt' ? +fromValue : +(+(toValue * tokenUSDT).toFixed(2)),
        ipAddress: '',
        clickId: trackingData['clickId'],
        source: trackingData['source'],
        hash: swapHash,
        chainId: chainId,
        presaleName: environment.presaleName,
        isBW: mode == 'bw',
        rABsZdfEqoXvExie: getParamWithoutCookie('rABsZdfEqoXvExie') || undefined,
      };
      console.log('BW data =', tokens, data);
      this.http.post(environment.bwApiUrl, data).subscribe(
        (res: any) => {
          console.log('BW success response', res);
        },
        (err: any) => {
          console.log('BW error response', err);
        },
      );
    }
  };

  refer(walletAddress: string) {
    const data = {
      walletAddress: walletAddress,
      iid: environment.iidDashFx,
    };
    this.http.post(environment.referUrl, data).subscribe(
      (res: any) => {
        // console.log('refer success response', res);
        this.referUrl = res.data ? res.data.url : '';
      },
      (err: any) => {
        // console.log('refer error response', err);
      },
    );
  }

  bestWalletModal(mode: string): void {
    const addClass = mode == 'walletBW' || mode == 'bw' ? 'modal-sm modal-dialog-centered bw-modal-isBw' : 'modal-lg modal-dialog-centered bw-modal';
    this.modalRef = this.modalService.show(BestwalletComponent, {
      class: addClass,
      backdrop: 'static',
      initialState: { isBw: mode == 'walletBW' || mode == 'bw' ? true : false },
    });
  }

  async vwoData(eventName: string, eventParams: any, hasParam = true) {
    if (typeof window == 'undefined') return;
    if (environment.production && environment.isVwoEnabled) {
      window.dataLayer = window.dataLayer || [];
      // Do not change anything in the following two lines
      window.VWO = window.VWO || [];
      window.VWO.event =
        window.VWO.event ||
        function () {
          window.VWO.push(['event'].concat([].slice.call(arguments)));
        };
      // Replace the property values with your actual values
      if (hasParam) window.VWO.event(eventName, eventParams);
      else window.VWO.event(eventName);
      console.log('event sent:', eventName, eventParams);
    }
  }
}
